import { Injectable } from '@angular/core';

export interface CheckAccessForFiltersAndActions {
  checkaccessforfiltersandactions(targetSlug: string): boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FilterBaseAccessService
  implements CheckAccessForFiltersAndActions {

  checkaccessforfiltersandactions(targetSlug: string): boolean {
  const storedpermissions = localStorage.getItem('auth_data');
  let slugGroups: { [parent_slug: string]: string[] } = {};

  try {
    const parsed = storedpermissions ? JSON.parse(storedpermissions) : {};
    slugGroups = parsed?.permissions?.slug_array || {};
  } catch {
    return false;
  }

  const normalizedTargetSlug = targetSlug?.trim().toLowerCase();

  return Object.values(slugGroups).some((slugs: string[]) =>
    slugs.some(
      (slug: string) =>
        slug?.trim().toLowerCase() === normalizedTargetSlug
    )
  );
}
}
